import * as React from "react";

function TagIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M5.927 13.177l4.896 4.896a.25.25 0 00.354 0l6.25-6.25a.25.25 0 00.073-.177V8.104c0-.01 0-.02-.002-.03L17.5 8a1.5 1.5 0 00-1.574-1.498.25.25 0 00-.03-.002h-3.543a.25.25 0 00-.176.073l-6.25 6.25a.25.25 0 000 .354z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M11.5 15v-4.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.854 12.396a.5.5 0 11-.708.708.5.5 0 01.708-.708zM13.854 12.396a.5.5 0 11-.708.708.5.5 0 01.708-.708z"
  }));
}

export default TagIcon;